module.exports = __webpack_public_path__ + "img/sales_promotions_2026.330f3374.jpg";